<template>
  <div>
    <!-- 面包屑导航 -->
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <a-breadcrumb style="margin: 16px 0">
        <a-breadcrumb-item>主页</a-breadcrumb-item>
        <a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
        <a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
        <a-breadcrumb-item>{{priceDiscountTitle}}</a-breadcrumb-item>
      </a-breadcrumb>
      <div>
        <a-button class="qinang-button-margin" icon="plus" @click="tableAdd">新增</a-button>
        <a-button class="qinang-button-margin" icon="edit" @click="tableEdit"  :disabled="!tableSelectedRows">修改</a-button>
        <a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
        <a-button icon="sync" @click="apiPriceDiscountDetailsList">刷新</a-button>
      </div>
    </div>

    <!-- 查询区域 -->
    <!-- <a-collapse expandIconPosition="right" activeKey="1">
      <a-collapse-panel key="1" header="优惠政策详情查询">
        <div style="display: flex; justify-content: space-between;">
          <div style="width: 30%; display: flex; align-items: center;">
            <div style="width: 120px;">服务商：</div>
            <a-select
              v-model="query.facilitatorId"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              style="width: 100%"
              placeholder="请选择服务商"
              allowClear
            >
              <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">
                {{ item.facilitatorName }}
              </a-select-option>
            </a-select>
          </div>
          <div style="width: 30%; display: flex; align-items: center; justify-content: flex-end;">
            <a-button type="primary" icon="search" @click="apiPriceDiscountDetailsList">查询</a-button>
          </div>
        </div>
      </a-collapse-panel>
    </a-collapse> -->

    <div class="qinang-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <a-breadcrumb separator=">" style="padding: 12.5px 16px;">
          <a-breadcrumb-item>优惠政策详情列表</a-breadcrumb-item>
        </a-breadcrumb>
        <a-tooltip placement="bottomRight">
          <template slot="title">
            <span>返回上一级</span>
          </template>
          <a-button type="link" @click="backMainNavigation"><i class="icon-sjp-fanhui"></i></a-button>
        </a-tooltip>
      </div>
      <a-table
        :row-selection="rowSelection"
        :columns="tableColumns"
        :data-source="tableData"
        row-key="priceDiscountDetailsId"
        :loading="tableLoading"
        :pagination="false"
      >
        <span slot="facilitatorName" slot-scope="text, record">
          {{ facilitatorList.find(item => item.facilitatorId === record.facilitatorId)?.facilitatorName || record.facilitatorId }}
        </span>
        <span slot="priceDiscountDetailsType" slot-scope="text, record">
          {{ priceDiscountTypeMap[String(record.priceDiscountDetailsType)] || record.priceDiscountDetailsType }}
        </span>
      </a-table>
      <a-pagination style="text-align: right; margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size"
        show-size-changer
        show-quick-jumper
        size="small" :page-size-options="['10', '20', '50']":showTotal="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
    </div>

    <!-- 添加弹窗 -->
    <a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible" @cancel="addHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
      <div style="width: 80%; background-color: #fff;">
        <a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
          <div class="qa-table-item-1-remarks">
            <a-form-model-item label="优惠政策">
              {{ priceDiscountTitle }}
            </a-form-model-item>
          </div>
          <!-- <div class="qa-table-item-1-remarks">
            <a-form-model-item label="服务商" has-feedback prop="facilitatorId">
              <a-select
                v-model="addForm.facilitatorId"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                placeholder="请选择服务商"
              >
                <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">
                  {{ item.facilitatorName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div> -->
          <div class="qa-table-item-1-remarks">
            <a-form-model-item label="规则类型" >
                  {{ priceDiscountTypeMap[priceDiscountType] || priceDiscountType }}
            </a-form-model-item>
          </div>
          <div class="qa-table-item-1-remarks">
            <a-form-model-item :label="priceDiscountType ==1?'最小数量':'最小金额'" has-feedback prop="minNumber">
              <a-input-number v-model="addForm.minNumber" :min="1" style="width: 100%" placeholder="请输入最小数字" />
            </a-form-model-item>
            <div class="qa-table-item-1-remarks-right" >(注：请输入大于 0 的数字)</div>
          </div>
          <div class="qa-table-item-1-remarks">
            <a-form-model-item :label="priceDiscountType ==1?'最大数量':'最大金额'" has-feedback prop="maxNumber">
              <a-input-number v-model="addForm.maxNumber" :min="1" style="width: 100%" placeholder="请输入最大数字" />
            </a-form-model-item>
            <div class="qa-table-item-1-remarks-right" >(注：请输入大于 0 的数字)</div>
          </div>
          <div class="qa-table-item-1-remarks" >
            <a-form-model-item class="formula-row" style="width: 800px;" label="优惠公式" has-feedback prop="discountFormula">
              <div class="formula-display" style="cursor: pointer;" @click="openSoftKeyboard('add')">
                {{ addForm.discountFormula || '无' }}
              </div>
            </a-form-model-item>
            <div class="qa-table-item-1-remarks-right" >(例：price*number*0.1)</div>
          </div>
          <div class="qa-table-item-1">
            <a-form-model-item label="备注" has-feedback prop="remark">
              <a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remark" />
            </a-form-model-item>
          </div>
          <div style="text-align: center;">
            <a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
            <a-button type="primary" @click="addHandleOk">保存</a-button>
          </div>
        </a-form-model>
      </div>
    </a-modal>

    <!-- 修改弹窗 -->
    <a-modal class="qa-modal" title="修改" width="100%" :visible="editVisible" @cancel="editHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
      <div style="width: 80%; background-color: #fff;">
        <a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
          <a-form-model-item label="优惠政策">
            {{ priceDiscountTitle }}
          </a-form-model-item>
          <!-- <div class="qa-table-item-1-remarks">
            <a-form-model-item label="服务商" has-feedback prop="facilitatorId">
              <a-select
                v-model="editForm.facilitatorId"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                placeholder="请选择服务商"
              >
                <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">
                  {{ item.facilitatorName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div> -->
          <div class="qa-table-item-1-remarks">
            <a-form-model-item label="规则类型">
                  {{ priceDiscountTypeMap[priceDiscountType] || priceDiscountType }}
            </a-form-model-item>
          </div>
          <div class="qa-table-item-1-remarks">
            <a-form-model-item :label="priceDiscountType ==1?'最小数量':'最小金额'" has-feedback prop="minNumber">
              <a-input-number v-model="editForm.minNumber" :min="1" style="width: 100%" placeholder="请输入最小数字" />
            </a-form-model-item>
            <div class="qa-table-item-1-remarks-right" style="">(注：请输入大于 0 的数字)</div>
          </div>
          <div class="qa-table-item-1-remarks">
            <a-form-model-item :label="priceDiscountType ==1?'最大数量':'最大金额'" has-feedback prop="maxNumber">
              <a-input-number v-model="editForm.maxNumber" :min="1" style="width: 100%" placeholder="请输入最大数字" />
            </a-form-model-item>
            <div class="qa-table-item-1-remarks-right" style="">(注：请输入大于 0 的数字)</div>
          </div>
          <div class="qa-table-item-1-remarks">
            <a-form-model-item class="formula-row" style="width: 800px;" label="优惠公式" has-feedback prop="discountFormula">
              <div class="formula-display"  @click="openSoftKeyboard('edit')">
                {{ editForm.discountFormula || '无' }}
              </div>
            </a-form-model-item>
            <div class="qa-table-item-1-remarks-right" style="">(例：price*number*0.1)</div>
          </div>
          <div class="qa-table-item-1">
            <a-form-model-item label="备注" has-feedback prop="remark">
              <a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remark" />
            </a-form-model-item>
          </div>
          <div style="text-align: center;">
            <a-button style="margin-right: 20px;" @click="editVisible = false">返回</a-button>
            <a-button type="primary" @click="editHandleOk">保存</a-button>
          </div>
        </a-form-model>
      </div>
    </a-modal>
    <!-- 软键盘弹窗 -->
    <a-modal title="优惠公式输入" :visible="showSoftKeyboard" @cancel="showSoftKeyboard = false" :footer="false" width="600px" style="z-index: 2000;">
      <div class="soft-keyboard">
        <div class="keyboard-display">
          <div class="formula-row">
            <div class="formula-display" style="flex: 1;">
              {{ tempDiscountFormula || '无' }}
            </div>
            <a-button @click="validateFormula">公式校验</a-button>
          </div>
        </div>
        <div class="keyboard-row">
          <div class="keyboard-row-left">
            <a-button @click="appendToFormula('7')" style="margin: 5px;">7</a-button>
            <a-button @click="appendToFormula('8')" style="margin: 5px;">8</a-button>
            <a-button @click="appendToFormula('9')" style="margin: 5px;">9</a-button>
          </div>
          <div class="keyboard-row-right" v-if="priceDiscountType ==1">
            <a-button @click="appendToFormula('price')" style="margin: 5px;">price</a-button>
            <a-button @click="appendToFormula('number')" style="margin: 5px;">number</a-button>
          </div>
          <div class="keyboard-row-right" v-else>
            <a-button @click="appendToFormula('total')" style="margin: 5px;">total</a-button>
          </div>
        </div>
        <div class="keyboard-row">
          <div class="keyboard-row-left">
            <a-button @click="appendToFormula('4')" style="margin: 5px;">4</a-button>
            <a-button @click="appendToFormula('5')" style="margin: 5px;">5</a-button>
            <a-button @click="appendToFormula('6')" style="margin: 5px;">6</a-button>
          </div>
          <div class="keyboard-row-right">
            <a-button @click="appendToFormula('(')" style="margin: 5px;">(</a-button>
            <a-button @click="appendToFormula(')')" style="margin: 5px;">)</a-button>
          </div>
        </div>
        <div class="keyboard-row">
          <div class="keyboard-row-left">
            <a-button @click="appendToFormula('1')" style="margin: 5px;">1</a-button>
            <a-button @click="appendToFormula('2')" style="margin: 5px;">2</a-button>
            <a-button @click="appendToFormula('3')" style="margin: 5px;">3</a-button>
          </div>
          <div class="keyboard-row-right">
            <a-button @click="appendToFormula('/')" style="margin: 5px;">/</a-button>
            <a-button @click="appendToFormula('*')" style="margin: 5px;">*</a-button>
          </div>
        </div>
        <div class="keyboard-row">
          <div class="keyboard-row-left">
            <a-button @click="appendToFormula('0')" style="margin: 5px;">0</a-button>
            <a-button @click="appendToFormula('.')" style="margin: 5px;">.</a-button>
            <a-button @click="backspaceFormula" style="margin: 5px;" type="dashed">回退</a-button>
          </div>
          <div class="keyboard-row-right">
            <a-button @click="appendToFormula('-')" style="margin: 5px;">-</a-button>
            <a-button @click="appendToFormula('+')" style="margin: 5px;">+</a-button>
          </div>
        </div>
        <div class="keyboard-row">
          <div class="keyboard-row-left">
            <a-button @click="clearFormula" style="margin: 5px;" danger>清空</a-button>
          </div>
          <div class="keyboard-row-right">
            <a-button @click="showSoftKeyboard = false">取消</a-button>
            <a-button @click="confirmFormula" style="margin: 5px;" type="primary" :disabled="!isValidFormula">确定</a-button>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
      selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
      // 优惠政策 ID（从路由参数获取）
      priceDiscountId: '',
      // 折扣规则类型
      priceDiscountType: '',
      // 折扣标题
      priceDiscountTitle:'',
      // 服务商 ID
      facilitatorId: undefined,
      // 服务商列表
      facilitatorList: [],
      // 规则类型列表
      priceDiscountTypeMap: {
        '1': '门票数量',
        '2': '总金额'
      },
      // 查询参数
      query: {
        page: 1,
        size: 10,
        total: 0,
        facilitatorId: undefined,
        priceDiscountId: ''
      },
      // 表格数据
      tableData: [],
      tableColumns: [
        { title: 'ID', dataIndex: 'priceDiscountDetailsId', key: 'priceDiscountDetailsId', align: 'center' },
        // { title: '优惠政策 ID', dataIndex: 'priceDiscountId', key: 'priceDiscountId', align: 'center' },
        { title: '服务商', key: 'facilitatorName', align: 'center', scopedSlots: { customRender: 'facilitatorName' } },
        { title: '规则类型', key: 'priceDiscountDetailsType', align: 'center', scopedSlots: { customRender: 'priceDiscountDetailsType' } },
        { title: '最小数量', dataIndex: 'minNumber', key: 'minNumber', align: 'center' },
        { title: '最大数量', dataIndex: 'maxNumber', key: 'maxNumber', align: 'center' },
        { title: '优惠公式', dataIndex: 'discountFormula', key: 'discountFormula', align: 'center' },
        { title: '备注', dataIndex: 'remark', key: 'remark', align: 'center' }
      ],
      tableLoading: false,
      tableSelectedRows: null,
      // 新增弹窗
      addVisible: false,
      addConfirmLoading: false,
      addForm: {
        priceDiscountId: '',
        facilitatorId: undefined,
        priceDiscountDetailsType: undefined,
        minNumber: 1,
        maxNumber: 1,
        discountFormula: '',
        remark: ''
      },
      addRules: {
        facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'change' }],
        minNumber: [{ required: true, message: '请输入大于0的数字', trigger: 'blur' }],
        maxNumber: [{ required: true, message: '请输入大于0的数字', trigger: 'blur' }],
      },
      // 软键盘弹窗
      showSoftKeyboard: false,
      // 公式验证状态
      isValidFormula: false,
      // 当前编辑的表单类型 ('add' 或 'edit')
      currentFormType: 'add',
      // 临时存储公式
      tempDiscountFormula: '',
      // 修改弹窗
      editVisible: false,
      editConfirmLoading: false,
      editForm: {
        priceDiscountDetailsId: '',
        priceDiscountId: '',
        facilitatorId: undefined,
        priceDiscountDetailsType: undefined,
        minNumber: 1,
        maxNumber: 1,
        discountFormula: '',
        remark: ''
      }
    };
  },

  methods: {
    // 软键盘相关方法
    openSoftKeyboard(formType) {
      this.currentFormType = formType;
      const form = this.getCurrentForm();
      this.tempDiscountFormula = form.discountFormula || '';
      this.isValidFormula = false;
      this.showSoftKeyboard = true;
    },
    confirmFormula() {
      const form = this.getCurrentForm();
      form.discountFormula = this.tempDiscountFormula;
      this.showSoftKeyboard = false;
    },
    getCurrentForm() {
      return this.currentFormType === 'add' ? this.addForm : this.editForm;
    },
    appendToFormula(value) {
      this.tempDiscountFormula += value;
    },
    clearFormula() {
      this.tempDiscountFormula = '';
    },
    backspaceFormula() {
      if (this.tempDiscountFormula.length > 0) {
        const formula = this.tempDiscountFormula;
        if (formula.endsWith('price')) {
          this.tempDiscountFormula = formula.slice(0, -5);
        } else if (formula.endsWith('number')) {
          this.tempDiscountFormula = formula.slice(0, -6);
        } else {
          this.tempDiscountFormula = formula.slice(0, -1);
        }
      }
    },
    validateFormula() {
      if (!this.tempDiscountFormula) {
        this.$message.warning('请输入优惠公式');
        this.isValidFormula = false;
        return;
      }
      
      try {
        // 替换 price 和 number 为 1
        const formula = this.tempDiscountFormula
          .replace(/price/g, '1')
          .replace(/number/g, '1')
          .replace(/total/g, '100');
          
        
        // 安全计算结果
        const result = eval(formula);
        
        // 检查结果是否为数字
        if (typeof result === 'number' && !isNaN(result)) {
          this.$message.success('公式验证通过');
          this.isValidFormula = true;
        } else {
          this.$message.error('公式结果不是数字');
          this.isValidFormula = false;
        }
      } catch (error) {
        this.$message.error('公式语法错误: ' + error.message);
        this.isValidFormula = false;
      }
    },
    // 返回上一页
    backMainNavigation() {
      window.sessionStorage.removeItem('priceDiscountMain');
      this.$router.go(-1);
    },

    // 获取服务商列表
    async apiFacilitatorList() {
      let priceDiscountMain = JSON.parse(window.sessionStorage.getItem('priceDiscountMain'));
      const { data: res } = await this.$http.post(this.navigation.apiFacilitatorList, {
        staffId: window.sessionStorage.getItem('staffId')
      });
      if (res.code == 200) {
        this.facilitatorList = res.data;
        if (priceDiscountMain && priceDiscountMain.length > 0) {
          this.query.facilitatorId = priceDiscountMain[0].facilitatorId;
        }
      } else {
        this.$message.error(res.msg);
      }
    },

    // 查询优惠政策详情列表
    async apiPriceDiscountDetailsList() {
      this.tableLoading = true;
      const { data: res } = await this.$http.post(this.navigation.apiPriceDiscountDetailsList, this.query);
      if (res.code == 200) {
        if (Array.isArray(res.data)) {
          this.tableData = res.data;
          this.query.total = res.data.length;
        } else {
          this.tableData = res.data.list || [];
          this.query.page = res.data.pages?.page || 1;
          this.query.size = res.data.pages?.size || 10;
          this.query.total = res.data.pages?.total || 0;
        }
        this.tableLoading = false;
      } else {
        this.$message.error(res.msg);
        this.tableLoading = false;
      }
    },

    // 分页变化
    pageChange(page, pageSize) {
      this.query.page = page;
      this.query.size = pageSize;
      this.apiPriceDiscountDetailsList();
    },

    showSizeChange(current, size) {
      this.query.page = current;
      this.query.size = size;
      this.apiPriceDiscountDetailsList();
    },

    // 过滤选项
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },

    // 取消弹窗
    addHandleCancel() {
      this.addVisible = false;
    },

    editHandleCancel() {
      this.editVisible = false;
    },

    // 新增
    tableAdd() {
      this.addForm = {
        priceDiscountId: this.priceDiscountId,
        priceDiscountDetailsType: this.priceDiscountType,
        minNumber: 1,
        maxNumber: 1,
        discountFormula: '',
        remark: ''
      };
      this.addVisible = true;
    },

    async apiPriceDiscountDetailsAdd() {
      let data = JSON.parse(JSON.stringify(this.addForm));
      data.priceDiscountId = this.priceDiscountId;
      data.facilitatorId = this.facilitatorId;
      console.log(data);
      const { data: res } = await this.$http.post(this.navigation.apiPriceDiscountDetailsAdd, data);
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.$refs.addRuleForm.resetFields();
        this.apiPriceDiscountDetailsList();
        this.addVisible = false;
      } else {
        this.$message.error(res.msg);
      }
    },

    addHandleOk() {
      this.$refs.addRuleForm.validate(valid => {
        if (valid) {
          if(this.addForm.discountFormula == ''){
            this.$message.error('请输入优惠公式');
            return false;
          }
          this.apiPriceDiscountDetailsAdd();
        } else {
          return false;
        }
      });
    },

    // 修改
    edit(item) {
      this.editForm = {
        ...item,
        priceDiscountDetailsType: String(item.priceDiscountDetailsType)
      };
      this.editVisible = true;
    },

    async apiPriceDiscountDetailsEdit() {
      const { data: res } = await this.$http.post(this.navigation.apiPriceDiscountDetailsEdit, this.editForm);
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.$refs.editRuleForm.resetFields();
        this.apiPriceDiscountDetailsList();
        this.tableSelectedRows = null;
        this.editVisible = false;
      } else {
        this.$message.error(res.msg);
      }
    },

    editHandleOk() {
      this.$refs.editRuleForm.validate(valid => {
        if (valid) {
          this.apiPriceDiscountDetailsEdit();
        } else {
          return false;
        }
      });
    },

    // 删除
    tableDel() {
      let that = this;
      if (this.tableSelectedRows) {
        this.$confirm({
          title: '确定要删除当前选中数据吗',
          content: '当前选中 1 条数据。',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk() {
            that.apiPriceDiscountDetailsDel();
          },
          onCancel() {}
        });
      } else {
        this.$message.warning('请选择要删除的数据');
      }
    },

    async apiPriceDiscountDetailsDel() {
      const { data: res } = await this.$http.post(this.navigation.apiPriceDiscountDetailsDel, {
        ids: [this.tableSelectedRows.priceDiscountDetailsId]
      });
      if (res.code == 200) {
        this.$message.success('删除成功');
        this.tableSelectedRows = null;
        this.apiPriceDiscountDetailsList();
      } else {
        this.$message.error(res.msg);
      }
    },

    // 编辑按钮点击事件
    tableEdit() {
      if (this.tableSelectedRows) {
        this.edit(this.tableSelectedRows);
      } else {
        this.$message.warning('请选择要修改的数据');
      }
    }
  },

  computed: {
    rowSelection() {
      let that = this;
      return {
        type: 'radio',
        selectedRowKeys: that.tableSelectedRows ? [that.tableSelectedRows.priceDiscountDetailsId] : [],
        onChange: (selectedRowKeys, selectedRows) => {
          if (that.tableSelectedRows && selectedRowKeys.length > 0 && 
            that.tableSelectedRows.priceDiscountDetailsId === selectedRowKeys[0]) {
            that.tableSelectedRows = null;
          } else {
            that.tableSelectedRows = selectedRows[0] || null;
          }
        }
      };
    }
  },

  created() {
    let priceDiscountMain = JSON.parse(window.sessionStorage.getItem('priceDiscountMain'));

    if (priceDiscountMain && priceDiscountMain.length > 1) {
      this.priceDiscountId = priceDiscountMain[1].priceDiscountId;
      this.query.priceDiscountId = this.priceDiscountId;
      this.priceDiscountType = priceDiscountMain[1].priceDiscountType;
      this.priceDiscountTitle = priceDiscountMain[1].title;
      this.facilitatorId = priceDiscountMain[0].facilitatorId;
    } else {
        // 获取 URL 参数
      this.priceDiscountId = this.$route.query.id || '';
      this.query.priceDiscountId = this.priceDiscountId;
    }
    

    this.apiFacilitatorList().then(() => {
      this.apiPriceDiscountDetailsList();
    });
  }
};
</script>
<style scoped>
.soft-keyboard {
  padding: 20px;
}

.keyboard-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.keyboard-row .ant-btn {
  min-width: 80px;
  text-align: center;
}

.keyboard-display {
  margin-bottom: 20px;
}

.formula-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.formula-display {
  padding: 0 11px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}

</style>

